// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"296":"21d620b7585f0865","453":"7cbbfea3b0ce065a","7875":"69670701b940e9cc","9464":"e838482039f1b262"}[chunkId] + ".js";
};